export interface InsuranceProvider {
  id: string;
  name: string;
  logo: string;
  logoColor: string;
  backgroundColor: string;
}

interface InsuranceCardProps {
  insurance: InsuranceProvider;
  isSelected: boolean;
  onClick: () => void;
  primaryColor?: string;
}

export function InsuranceCard({
  insurance,
  isSelected,
  onClick,
}: InsuranceCardProps) {
  return (
    <div
      onClick={onClick}
      className={`cursor-pointer transition-all duration-300 transform hover:scale-105 rounded-xl p-6 shadow-sm border h-full flex items-center space-x-4 ${
        isSelected ? 'shadow-lg' : 'hover:shadow-lg'
      }`}
      style={{
        background: isSelected ? 'var(--clinic-main)' : '#FFFFFF',
        borderColor: isSelected ? 'var(--clinic-main)' : '#E5E7EB',
      }}
    >
      {/* Logo Container */}
      <div
        className='w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0'
        style={{
          backgroundColor: isSelected ? '#FFFFFF' : insurance.backgroundColor,
        }}
      >
        <div
          className='font-semibold text-sm'
          style={{
            color: isSelected ? 'var(--clinic-primary)' : insurance.logoColor,
          }}
        >
          {insurance.logo}
        </div>
      </div>

      {/* Insurance Name */}
      <div className='flex-1'>
        <h3
          className='font-medium text-lg'
          style={{
            color: isSelected ? '#FFFFFF' : '#111827',
          }}
        >
          {insurance.name}
        </h3>
      </div>
    </div>
  );
}
